import {RESOLVE_LOCALE_FROM_PROGRAM} from '.';

const resolveLocaleFromProgram = (locale) => {
  return (dispatch) => {
    dispatch({
      type: RESOLVE_LOCALE_FROM_PROGRAM,
      locale: locale
    });
  };
};

export default resolveLocaleFromProgram;
